import React from "react";

const Privacypolicy = () => {
  return (
    <section className="banner_section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="build_web_app-title flex-column privacypolicy-section mb-0">
              <h2
                className="text-center w-100 mb-4"
                style={{ maxWidth: "100%" }}
              >
                Privacy Policy
              </h2>
              <p>
                <strong>Effective Date:</strong> Jun-15-2025
              </p>
              <p>
                Welcome to Launch e Store. Your privacy is important to us, and
                we are committed to protecting the personal information you
                share with us. This Privacy Policy outlines how we collect, use,
                store, and protect your information when you use our website,
                mobile applications, and vendor services.
              </p>

              <h3>1. About Launch e Store</h3>
              <p>
                Launch e Store is a dynamic digital platform that enables
                business owners to create and manage their own e-commerce or
                informative websites in just minutes. We offer a range of
                pre-developed templates, e-commerce solutions, and business
                management tools, including a powerful admin panel and mobile
                application.
              </p>
              <p>Users can manage:</p>
              <ul>
                <li>Website themes, colors, logos, menus, and banners</li>
                <li>Offers, categories, brands, products, and variants</li>
                <li>Galleries, product highlights, blogs, and order notes</li>
                <li>Orders, deliveries, and customer interactions</li>
              </ul>
              <p>
                Our platform is fully dynamic, offering extensive customization
                and control through a secure cloud-based system.
              </p>

              <h3>2. What Information We Collect</h3>
              <h4>a. For Website Users & App Users</h4>
              <ul>
                <li>Name, email address, and contact details</li>
                <li>Location (with permission, only for delivery purposes)</li>
                <li>Device and browser information</li>
                <li>IP address and usage data for analytics</li>
              </ul>
              <h4>b. For Vendors/Business Owners</h4>
              <ul>
                <li>Business name and contact information</li>
                <li>
                  Payment and billing details (via third-party processors)
                </li>
                <li>
                  Website content, product information, and customer data
                  entered through the platform
                </li>
              </ul>

              <h3>3. How We Use Your Information</h3>
              <ul>
                <li>Provide and improve our services</li>
                <li>Manage user accounts and vendor dashboards</li>
                <li>Enable e-commerce functionality and order tracking</li>
                <li>Deliver technical support and customer service</li>
                <li>Send important notices (e.g., updates, security alerts)</li>
              </ul>

              <h3>4. Data Storage & Security</h3>
              <p>
                All personal and business data is securely stored in encrypted
                form on trusted cloud infrastructure. We employ
                industry-standard security protocols to prevent unauthorized
                access, misuse, or disclosure. Data transmission between users
                and our servers is encrypted using SSL/TLS. Access to data is
                restricted based on role and purpose.
              </p>

              <h3>5. Data Encryption</h3>
              <p>
                All data is end-to-end encrypted to ensure privacy and
                integrity. Sensitive information such as passwords and financial
                details are securely hashed or tokenized.
              </p>

              <h3>6. Location Permissions</h3>
              <p>
                Location data is only requested and used for delivery or
                logistics-related features. We do not store or share precise
                location information without your permission.
              </p>

              <h3>7. User Consent</h3>
              <p>
                By using our website or mobile application, you consent to our
                collection and use of your information as described in this
                policy.
              </p>

              <h3>8. Third-Party Services</h3>
              <p>
                We may use third-party tools or services (e.g., payment
                gateways, analytics tools) which have their own privacy
                policies. We encourage users to review those policies as
                applicable.
              </p>

              <h3>9. Vendor Responsibility</h3>
              <p>Vendors/business owners are solely responsible for:</p>
              <ul>
                <li>
                  The accuracy and legality of the content displayed on their
                  websites
                </li>
                <li>
                  Managing their own customer data in compliance with applicable
                  laws
                </li>
                <li>
                  Ensuring their usage of the platform complies with our terms
                  of service
                </li>
              </ul>
              <p>
                Launch e Store does not create, edit, or verify the content
                added by vendors.
              </p>

              <h3>10. Data Sharing</h3>
              <p>
                We do not sell, trade, or rent users' personal data to any third
                parties. Data may be shared only with trusted service providers
                or authorities when legally required.
              </p>

              <h3>11. User Rights</h3>
              <p>Users and vendors have the right to:</p>
              <ul>
                <li>Access their personal data</li>
                <li>Request correction or deletion</li>
                <li>
                  Withdraw consent at any time (which may affect access to some
                  features)
                </li>
              </ul>
              <p>
                To request any of the above, please contact us at:{" "}
                <a href="mailto:support@youremail.com">support@youremail.com</a>
              </p>

              <h3>12. Children’s Privacy</h3>
              <p>
                Our platform is not intended for use by individuals under the
                age of 13. We do not knowingly collect personal data from
                children.
              </p>

              <h3>13. Policy Updates</h3>
              <p>
                This Privacy Policy may be updated periodically to reflect
                changes in legal requirements or service enhancements. We will
                notify users of significant changes through our app or website.
              </p>

              <h3>14. Contact Us</h3>
              <p>
                If you have any questions or concerns about this Privacy Policy,
                please contact:
              </p>
              <p>
                <strong>Launch e Store Support</strong>
                <br />
                Email:{" "}
                <a href="mailto:support@youremail.com">support@youremail.com</a>
                <br />
                Website:{" "}
                <a href="https://www.launchestore.com" target="_blank">
                  https://www.launchestore.com
                </a>
              </p>

              <h3>15. Contact Permission (Access to Device Contacts)</h3>
              <p>
                Our business application may request permission to access your
                device's contact list. This permission is solely used to help
                you search and identify customers quickly by matching names and
                phone numbers from your contacts.
              </p>
              <p>
                <strong>Key points:</strong>
              </p>
              <ul>
                <li>
                  {" "}
                  <strong>Local Use Only:</strong> The app accesses your
                  contacts locally on your device.
                </li>
                <li>
                  {" "}
                  <strong>No Syncing or Uploading:</strong> We do not sync,
                  upload, or store your contact data on our servers.
                </li>
                <li>
                  {" "}
                  <strong>Search Purpose Only:</strong> Contact access is only
                  used to assist in auto-filling customer names or numbers when
                  adding a new customer.
                </li>
                <li>
                  {" "}
                  <strong>No Unintended Use:</strong> We do not send messages,
                  access other contact details, or use this permission for
                  marketing or analytics purposes.
                </li>
              </ul>
              <p>
                You can disable this permission at any time in your device
                settings, but doing so may limit your ability to quickly find
                and add existing customers from your device contact list.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacypolicy;
